import { useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link, NavLink, localizePath, stripLang, useLang } from '../i18n';
import { CLASSES_LOGIN_URL, COURSE_LOGIN_URL, MEDIA, whatsappUrl } from '../data/siteData';

export default function Navbar() {
  const { lang, t } = useLang();
  const { pathname, search, hash } = useLocation();
  const switchTo = (target) => `${localizePath(stripLang(pathname), target)}${search}${hash}`;
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <nav className={`navbar ${menuOpen ? 'menu-open' : ''}`}>
      <div className="container navbar-inner">
        <Link to="/" className="navbar-logo" aria-label={t('Speak English Now, inicio', 'Speak English Now, inici')}><img className="brand-full" src={MEDIA.logo} alt="" /><img className="brand-mark" src={MEDIA.logoMark} alt="" /><span className="brand-name">Speak English Now</span></Link>

        <button
          className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => { setMenuOpen(!menuOpen); setLoginOpen(false); }}
          aria-label={menuOpen ? t('Cerrar menú', 'Tancar menú') : t('Abrir menú', 'Obrir menú')}
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
        >
          <span /><span /><span />
        </button>

        <ul id="main-navigation" className={`navbar-nav ${menuOpen ? 'open' : ''}`}>
          <li className="mobile-menu-header">
            <span>{t('MENÚ', 'MENÚ')}</span>
            <strong>{t('¿Qué quieres descubrir?', 'Què vols descobrir?')}</strong>
          </li>
          <li><NavLink to="/" end onClick={() => setMenuOpen(false)}><span className="nav-item-number">01</span><span className="nav-link-copy"><span>{t('Home', 'Inici')}</span><small>{t('Todo lo que puedes encontrar', 'Tot el que pots trobar')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li><NavLink to="/curso-online" onClick={() => setMenuOpen(false)}><span className="nav-item-number">02</span><span className="nav-link-copy"><span>SEN Pro</span><small>{t('Programa online paso a paso', 'Programa en línia pas a pas')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li><NavLink to="/clases" onClick={() => setMenuOpen(false)}><span className="nav-item-number">03</span><span className="nav-link-copy"><span>{t('Clases', 'Classes')}</span><small>{t('Online, presenciales y empresas', 'En línia, presencials i empreses')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li><NavLink to="/nosotros" onClick={() => setMenuOpen(false)}><span className="nav-item-number">04</span><span className="nav-link-copy"><span>{t('Sobre SEN', 'Sobre SEN')}</span><small>{t('Caroline, el equipo y el método', 'La Caroline, l\'equip i el mètode')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li><NavLink to="/blog" onClick={() => setMenuOpen(false)}><span className="nav-item-number">05</span><span className="nav-link-copy"><span>Blog</span><small>{t('Consejos para mejorar tu inglés', 'Consells per millorar el teu anglès')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li><NavLink to="/contacto" onClick={() => setMenuOpen(false)}><span className="nav-item-number">06</span><span className="nav-link-copy"><span>{t('Contacto', 'Contacte')}</span><small>{t('Te ayudamos a elegir', 'T\'ajudem a triar')}</small></span><span className="nav-item-arrow">→</span></NavLink></li>
          <li className="mobile-menu-footer">
            <a href={whatsappUrl(t('Hola Caroline, quiero saber qué opción de Speak English Now es mejor para mí', 'Hola Caroline, vull saber quina opció de Speak English Now és millor per a mi'))} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>
              <span>{t('Hablar por WhatsApp', 'Parlar per WhatsApp')}</span><span>↗</span>
            </a>
          </li>
        </ul>

        {menuOpen && <button className="mobile-nav-backdrop" onClick={() => setMenuOpen(false)} aria-label={t('Cerrar menú', 'Tancar menú')} />}

        <div className="lang-switch" role="group" aria-label={t('Idioma', 'Idioma')}>
          <RouterLink to={switchTo('es')} className={lang === 'es' ? 'is-active' : ''} hrefLang="es" lang="es" aria-current={lang === 'es' ? 'true' : undefined} onClick={() => setMenuOpen(false)}>ES</RouterLink>
          <RouterLink to={switchTo('ca')} className={lang === 'ca' ? 'is-active' : ''} hrefLang="ca" lang="ca" aria-current={lang === 'ca' ? 'true' : undefined} onClick={() => setMenuOpen(false)}>CA</RouterLink>
        </div>

        <div
          className="nav-login-wrap"
          onMouseEnter={() => setLoginOpen(true)}
          onMouseLeave={() => setLoginOpen(false)}
        >
          <button className="nav-login-btn" onClick={() => { setLoginOpen(!loginOpen); setMenuOpen(false); }} aria-label={t('Iniciar sesión', 'Iniciar sessió')}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            <span className="nav-login-text">{t('Iniciar sesión', 'Iniciar sessió')}</span>
          </button>

          {loginOpen && (
            <div className="nav-login-dropdown">
              <div className="login-dropdown-header">
                <span className="login-dropdown-title">{t('¿Dónde quieres entrar?', 'On vols entrar?')}</span>
                <p>{t('Elige la plataforma a la que quieres acceder', 'Tria la plataforma a la qual vols accedir')}</p>
              </div>

              <a href={CLASSES_LOGIN_URL} target="_blank" rel="noopener noreferrer" className="login-option" onClick={() => setLoginOpen(false)}>
                <div className="login-icon login-icon-teal">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/>
                  </svg>
                </div>
                <div className="login-option-text">
                  <strong>{t('Clases Online', 'Classes en línia')}</strong>
                  <span>{t('Plataforma School Mate', 'Plataforma School Mate')}</span>
                </div>
                <svg className="login-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>

              <a href={COURSE_LOGIN_URL} target="_blank" rel="noopener noreferrer" className="login-option" onClick={() => setLoginOpen(false)}>
                <div className="login-icon login-icon-purple">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
                  </svg>
                </div>
                <div className="login-option-text">
                  <strong>{t('Curso Online', 'Curs en línia')}</strong>
                  <span>{t('Acceso a la plataforma Pro', 'Accés a la plataforma Pro')}</span>
                </div>
                <svg className="login-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>

              <div className="login-dropdown-footer">
                {t('¿Aún no tienes cuenta?', 'Encara no tens compte?')} <Link to="/contacto" onClick={() => setLoginOpen(false)}>{t('Contáctanos', 'Contacta\'ns')}</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
